import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AppHeader from './AppHeader';
import BottomNav from './BottomNav';



// Patient Pages
import PatientHome from '../pages/patient/home/Home';
import PatientSubscription from '../pages/patient/subscription/Subscription';
import PatientConsultation from '../pages/patient/consultation/Consultation';
import PatientDoctors from '../pages/patient/doctors/Doctors';
import PatientHistory from '../pages/patient/history/History';
import PatientProfile from '../pages/patient/profile/Profile';
import PatientSupport from '../pages/patient/support/Support';
import PatientMedicines from '../pages/patient/medicines/Medicines';
import PatientYoga from '../pages/patient/yoga/Yoga';
import LiveClass from '../pages/patient/live-class/LiveClass';
import Ambulance from '../pages/patient/Ambulance';
import FoodLinks from '../pages/patient/FoodLinks';
import PatientOrders from '../pages/patient/medicines/Orders';
import PatientCart from '../pages/patient/medicines/Cart';
import PatientPodcasts from '../pages/patient/podcasts/Podcasts';
import NotificationHistory from '../pages/patient/notifications/NotificationHistory';
import MedicalRecords from '../pages/patient/medical-records/MedicalRecords';
import EmergencyRequest from '../pages/patient/emergency/EmergencyRequest';
import AppointmentBooking from '../pages/patient/appointments/AppointmentBooking';
import SecuritySettings from '../pages/auth/SecuritySettings';
import AuditLog from '../pages/admin/AuditLog';

// Doctor Pages
import DoctorDashboard from '../pages/doctor/dashboard/Dashboard';
import DoctorConsultation from '../pages/doctor/consultation/Consultation';
import DoctorPatients from '../pages/doctor/patients/Patients';
import DoctorProfile from '../pages/doctor/profile/Profile';
import DoctorWallet from '../pages/doctor/wallet/Wallet';

// Retailer Pages
import RetailerDashboard from '../pages/retailer/dashboard/Dashboard';
import RetailerProducts from '../pages/retailer/products/Products';
import RetailerOrders from '../pages/retailer/orders/Orders';
import RetailerProfile from '../pages/retailer/profile/Profile';
import RetailerWallet from '../pages/retailer/wallet/Wallet';

// Clinic Pages
import ClinicDashboard from '../pages/clinic/dashboard/Dashboard';
import ClinicConsultation from '../pages/clinic/consultation/Consultation';
import ClinicPatients from '../pages/clinic/patients/Patients';
import ClinicDoctors from '../pages/clinic/doctors/Doctors';
import ClinicProfile from '../pages/clinic/profile/Profile';
import ClinicWallet from '../pages/clinic/wallet/Wallet';

// Hospital Pages
import HospitalDashboard from '../pages/hospital/dashboard/Dashboard';
import HospitalConsultation from '../pages/hospital/consultation/Consultation';
import HospitalPatients from '../pages/hospital/patients/Patients';
import HospitalProfile from '../pages/hospital/profile/Profile';
import HospitalWallet from '../pages/hospital/wallet/Wallet';
import HospitalSubscription from '../pages/hospital/subscription/Subscription';

import DoctorSubscription from '../pages/doctor/subscription/Subscription';
import RetailerSubscription from '../pages/retailer/subscription/Subscription';
import ClinicSubscription from '../pages/clinic/subscription/Subscription';

const MobileLayout = () => {
  const { user } = useAuth();

  // Map clinic_doctor and hospital_doctor to standard 'doctor' UI paths
  const effectiveRole = ['clinic_doctor', 'hospital_doctor'].includes(user?.role)
    ? 'doctor'
    : (user?.role || 'patient');

  return (
    <div className="bg-dark h-full min-h-screen">
      {/* App Header - Fixed at top with safe-area padding */}
      <div className="fixed top-0 w-full z-50">
        <AppHeader />
      </div>

      {/* Main Content - Scrollable area */}
      {/* Uses explicit padding to ensure content scrolls cleanly under Header and BottomNav */}
      <main className="w-full min-h-screen overflow-y-auto px-4 pt-[calc(5rem+env(safe-area-inset-top))] pb-[calc(6rem+env(safe-area-inset-bottom))]">
        <div className="w-full max-w-mobile mx-auto">
          <Routes>
            {/* ... routes ... */}
            {/* Patient Routes */}
            <Route path="/patient/home" element={<PatientHome />} />
            <Route path="/patient/subscription" element={<PatientSubscription />} />
            <Route path="/patient/consultation" element={<PatientConsultation />} />
            <Route path="/patient/doctors" element={<PatientDoctors />} />
            <Route path="/patient/medicines" element={<PatientMedicines />} />
            <Route path="/patient/yoga" element={<PatientYoga />} />
            <Route path="/patient/history" element={<PatientHistory />} />
            <Route path="/patient/profile" element={<PatientProfile />} />
            <Route path="/patient/support" element={<PatientSupport />} />
            <Route path="/patient/consultation/book/:doctorId" element={<PatientConsultation />} />
            <Route path="/patient/live-class/:id" element={<LiveClass />} />
            <Route path="/patient/ambulance" element={<Ambulance />} />
            <Route path="/patient/food-links" element={<FoodLinks />} />
            <Route path="/patient/orders" element={<PatientOrders />} />
            <Route path="/patient/cart" element={<PatientCart />} />
            <Route path="/patient/podcasts" element={<PatientPodcasts />} />
            <Route path="/patient/notifications" element={<NotificationHistory />} />
            <Route path="/patient/medical-records" element={<MedicalRecords />} />
            <Route path="/patient/emergency" element={<EmergencyRequest />} />
            <Route path="/patient/appointments" element={<AppointmentBooking />} />
            <Route path="/security-settings" element={<SecuritySettings />} />
            <Route path="/admin/audit-logs" element={<AuditLog />} />

            {/* Doctor Routes */}
            <Route path="/dashboard/doctor/home" element={<DoctorDashboard />} />
            <Route path="/dashboard/doctor/consultation" element={<DoctorConsultation />} />
            <Route path="/dashboard/doctor/patients" element={<DoctorPatients />} />
            <Route path="/dashboard/doctor/profile" element={<DoctorProfile />} />
            <Route path="/dashboard/doctor/wallet" element={<DoctorWallet />} />
            <Route path="/dashboard/doctor/subscription" element={<DoctorSubscription />} />

            {/* Retailer Routes */}
            <Route path="/dashboard/retailer/home" element={<RetailerDashboard />} />
            <Route path="/dashboard/retailer/products" element={<RetailerProducts />} />
            <Route path="/dashboard/retailer/orders" element={<RetailerOrders />} />
            <Route path="/dashboard/retailer/profile" element={<RetailerProfile />} />
            <Route path="/dashboard/retailer/wallet" element={<RetailerWallet />} />
            <Route path="/dashboard/retailer/subscription" element={<RetailerSubscription />} />

            {/* Clinic Routes */}
            <Route path="/dashboard/clinic/home" element={<ClinicDashboard />} />
            <Route path="/dashboard/clinic/consultation" element={<ClinicConsultation />} />
            <Route path="/dashboard/clinic/patients" element={<ClinicPatients />} />
            <Route path="/dashboard/clinic/doctors" element={<ClinicDoctors />} />
            <Route path="/dashboard/clinic/profile" element={<ClinicProfile />} />
            <Route path="/dashboard/clinic/wallet" element={<ClinicWallet />} />
            <Route path="/dashboard/clinic/subscription" element={<ClinicSubscription />} />

            {/* Hospital Routes */}
            <Route path="/dashboard/hospital/home" element={<HospitalDashboard />} />
            <Route path="/dashboard/hospital/consultation" element={<HospitalConsultation />} />
            <Route path="/dashboard/hospital/patients" element={<HospitalPatients />} />
            <Route path="/dashboard/hospital/profile" element={<HospitalProfile />} />
            <Route path="/dashboard/hospital/wallet" element={<HospitalWallet />} />
            <Route path="/dashboard/hospital/subscription" element={<HospitalSubscription />} />

            {/* Default redirect based on role */}
            <Route path="/*" element={
              user?.role === 'patient' ? (
                <Navigate to="/patient/home" replace />
              ) : (
                <Navigate to={`/dashboard/${effectiveRole}/home`} replace />
              )
            } />
          </Routes>
        </div>
      </main>

      {/* Bottom Navigation - Fixed at bottom with safe-area padding inside BottomNav itself */}
      <div className="fixed bottom-0 w-full z-50">
        <BottomNav />
      </div>
    </div>
  );
};

export default MobileLayout;
